<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.entradaInicial"
            ref="DataTable"
            sort-by="descricao"
            search-by="descricao"
        >
            <template v-slot:cell(isAtivo)="{ item }">
                {{ item.isAtivo ? 'ATIVO' : 'INATIVO' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="$refs.ModalMaterial.open(item)"
                    authorize="store-almoxarifado-entrada-inicial"
                    color="primary"
                    small
                    title="Cadastrar entrada"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalMaterial
            @save="$refs.DataTable.refresh()"
            ref="ModalMaterial"
        />
    </div>
</template>

<script>
// Components.
import ModalMaterial from './components/material/Modal'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { ModalMaterial },
    created() {

        this.repositories = {
            entradaInicial: this.getConectaSusRepository('almoxarifado.entradaInicial')
        }
    },
    computed: {
        fields() {

            return [
                {
                    name: 'cadastroMaterial.codigoMaterial',
                    key: 'codigoMaterial',
                    label: 'Código do material',
                    class: 'col-min',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'descricao',
                    key: 'descricao',
                    label: 'Descrição',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroGrupo.nome',
                    key: 'grupo',
                    label: 'Grupo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroSubgrupo.nome',
                    key: 'subgrupo',
                    label: 'Subgrupo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroMaterial.isAtivo',
                    key: 'isAtivo',
                    label: 'Status',
                    class: 'col-min'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    mixins: [ repository, formats ],
}
</script>